import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import {setupBeforeEach} from "~/router/before-each";

import AuthRoutes from "~/modules/auth/routes";
import AppLayout from "~/layouts/app-layout";
import {ClientView} from "~/modules/client/client-view";
import {UsersView} from "~/modules/users/users-view";
import {UsersEdit} from "~/modules/users/users-edit";
import {StatsView} from "~/modules/stats/stats-view";
import {ClientListView} from "~/modules/partner";
import {ClientHome} from "~/modules/client";
import {NotificationsView} from "~/modules/notifications/notifications-view";
import {SettingsView} from "~/modules/settings/settings-view";
import {HomePageEdit} from "~/modules/homepage/homepage-edit";
import {HomepagesList} from "~/modules/homepage/homepages-list";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: AppLayout,
    meta: {requiresAuth: true},
    children: [
      { path: '', name: 'partner_home',component: ClientListView},
      {path: "notifications", name: "partners_notifications", component: NotificationsView},
      {
        path: ":clientUuid",
        name: "home",
        component: ClientHome,
        redirect: { name: 'client' },
        children: [
          {path: "/", name: "client", component: ClientView},
          {path: "users", name: "users", component: UsersView},
          {path: "users/edit/:uuid", name: "users-edit", component: UsersEdit},
          {path: "settings", name: "settings", component: SettingsView},
          {path: "stats", name: "stats", component: StatsView},
          {path: "notifications", name: "notifications", component: NotificationsView},
          {path: "homepages", name: "homepages", component: HomepagesList},
          {path: "homepages/edit/:uuid", name: "homepages-edit", component: HomePageEdit},
        ]
      },
    ]
  },
  ...AuthRoutes,
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

setupBeforeEach(router);

export default router
